
import React, { Fragment, useCallback } from "react";
import { useAPI } from "components/lib";
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import Axios from "axios";
import "survey-core/defaultV2.min.css";
import { applyStackgoTheme } from "components/survey/stackgo-theme";

StylesManager.applyTheme("defaultV2");

export function KarbonSettingsView(props) {
  const existingSettingsResponse = useAPI("/api/integration/karbon");
  const env = process.env.NODE_ENV;
  const navigateToUrl =
    env === "production"
      ? `https://identity.stackgo.io/account`
      : `http://localhost:3000/account`;

  function setExistingFYISettings() {
    if (
      existingSettingsResponse.loading === false &&
      existingSettingsResponse.data !== null
    ) {
      const settings = existingSettingsResponse?.data?.[0];
      survey.setValue("enabled", settings?.enabled);
      survey.setValue("karbon_access_key", settings?.data?.karbon_access_key);
      survey.setValue("karbon_note_email", settings?.data?.karbon_note_email)
      // feature 007: Tranche 2 section
      survey.setValue("tranche2_enabled", settings?.data?.tranche2?.enabled === true);
      survey.setValue(
        "tranche2_task_type",
        settings?.data?.tranche2?.karbon_task_check_type === "tranche2" ? "tranche2" : "kyc"
      );
    }
  }
  const json = {
    completedHtml: "<h3>Your changes have been saved.</h3>",
    showQuestionNumbers: "off",
    pages: [
      {
        name: "KarbonSettingsView",
        elements: [
          {
            type: "boolean",
            name: "enabled",
            title: "Enabled",
            isRequired: true,
            defaultValue: false,
          },
          {
            type: "text",
            name: "karbon_access_key",
            title: "Karbon Access Key",
            isRequired: true,
          },
          {
            type: "text",
            "inputType": "email",
            name: "karbon_note_email",
            title: "Karbon Note Email",
            description: "Email address to use for posting notes into Karbon. Note must be an active user in Karbon.",
            isRequired: true,
          },
          {
            type: "html",
            name: "integration_task_info",
            html: "<div style='padding: 12px; background: #f0f4f8; border-radius: 6px; margin-top: 8px;'><strong>Integration Workflows</strong><br/><br/>When enabled, two verification triggers are active:<br/><ul><li><strong>Note-based:</strong> Create a note in Karbon with &lt;kyc&gt; in the subject to trigger a verification.</li><li><strong>IntegrationTask-based:</strong> Use the \"IdentityCheck - KYC\" IntegrationTask in Karbon to trigger a verification. Task status will be automatically updated with the result.</li></ul></div>",
          },
          {
            type: "boolean",
            name: "tranche2_enabled",
            title: "Enable Tranche 2 (AML) triggers & writebacks",
            description: "Note triggers: use <aml> in the note subject for Tranche 2 (and <kyc> for KYC). Tranche 2 results are written back to the client profile.",
            defaultValue: false,
          },
          {
            type: "dropdown",
            name: "tranche2_task_type",
            title: "Karbon task verification type",
            description: "Which check an IntegrationTask trigger starts.",
            defaultValue: "kyc",
            visibleIf: "{tranche2_enabled} = true",
            choices: [
              { value: "kyc", text: "KYC" },
              { value: "tranche2", text: "Tranche 2 (AML)" },
            ],
          }
        ],
      },
    ],
  };

  json.navigateToUrl = navigateToUrl;

  async function saveSurveyResults(url, json) {
    console.log("saveSettings", url, json);
    const response = await Axios.post(url, json);
  }

  const karbonSettingsAdded = useCallback((sender) => {
    // feature 007: nest the flat T2 fields into the tranche2 block the backend expects.
    const data = { ...sender.data };
    data.tranche2 = {
      enabled: data.tranche2_enabled === true,
      karbon_task_check_type:
        data.tranche2_task_type === "tranche2" ? "tranche2" : "kyc",
    };
    delete data.tranche2_enabled;
    delete data.tranche2_task_type;
    saveSurveyResults("/api/integration/karbon", data);
  });

  const survey = new Model(json);
  applyStackgoTheme(survey);
  survey.onComplete.add(karbonSettingsAdded);
  setExistingFYISettings();

  return (
    <Fragment>
      <Survey model={survey} />
    </Fragment>
  );
}
